import { Link, useRouter } from "easy-page-router/react";

import { csDict, esDict, enDict, useLang, Dictionary, languages, getLang } from "../services/lang";
import { Lang } from "../../types";
import { useMemo } from "react";

export function LangSwitch() {
    const { path, keyPath } = useKeyPath();

    return <div className="lang-switch">
        <Link onClick={() => saveSelectedLang("en")} href={getLangUrl("en", path, keyPath)} className="flag flag-en">English</Link>
        <Link onClick={() => saveSelectedLang("es")} href={getLangUrl("es", path, keyPath)} className="flag flag-es">Español</Link>
        <Link onClick={() => saveSelectedLang("cs")} href={getLangUrl("cs", path, keyPath)} className="flag flag-cs">Čeština</Link>
    </div>;
}

function saveSelectedLang(lang: Lang) {
    if (!global.localStorage) return;

    localStorage.setItem("selectedLang", lang);
}

export function useSelectedLang(): null | Lang {
    if (!global.localStorage) return null;

    const lang = localStorage.getItem("selectedLang") as Lang;
    if (languages.includes(lang))
        return lang;

    return null;
}

type Key = null | keyof Dictionary;

function useKeyPath(): { lang: Lang, path: string[], keyPath: Key[] } {
    let { path } = useRouter();
    const { lang, dict } = useLang();

    if (path.length === 0)
        path[0] = "";

    const keyPath = useMemo(() => {
        return path.map<Key>(p => {
            for (const key in dict) {
                if (key.startsWith("url") && dict[key] === p) {
                    return key as keyof Dictionary;
                }
            }

            return null;
        });
    }, [lang, path]);

    return { lang, path, keyPath };
}

function getLangUrl(lang: Lang, path: string[], keyPath: Key[]): string {
    const dict = lang === "cs" ? csDict : lang === "es" ? esDict : enDict;

    return "/" + keyPath.map((key, i) => {
        if (!key) {
            return path[i];
        } else {
            return dict[key];
        }
    }).join("/");
}